/**
 * lastRound: 직전 확정 차수 편성을 금회 절대액 초안으로 복제
 * (저장 전 draft — 화면에서 mod=A 로 표시 후 F10 저장)
 */
import {
  isLastRoundMode,
} from 'budget/budgetTenantSettingsStore';
import { loadPriorRoundRowsForLastRound } from 'budget/budgetBaselineStore';
import {
  defaultMasterRow as defaultExpenseMaster,
  defaultDetailRow as defaultExpenseDetail,
} from 'budget/budgetExpenseRequestStore';
import {
  defaultMasterRow as defaultIncomeMaster,
  defaultDetailRow as defaultIncomeDetail,
} from 'budget/budgetIncomeRequestStore';

function cloneMasterFromPrior(src, factory, detailFactory) {
  const amt = Number(src.budgetAmt) || 0;
  const details =
    Array.isArray(src.details) && src.details.length
      ? src.details.map((d) =>
          detailFactory({
            calcLevel: d.calcLevel || 1,
            calcDesc: d.calcDesc || '',
            calcBasis: d.calcBasis || '',
            calcAmt: Number(d.calcAmt) || 0,
            remark: d.remark || '',
            mod: 'A',
          })
        )
      : amt
        ? [
            detailFactory({
              calcLevel: 1,
              calcDesc: '직전차수 이월',
              calcBasis: String(amt),
              calcAmt: amt,
              mod: 'A',
            }),
          ]
        : [];
  return factory({
    deptCode: src.deptCode || '',
    deptName: src.deptName || '',
    projectCode: src.projectCode || '',
    projectName: src.projectName || '',
    subjectUid: src.subjectUid || '',
    subjectCode: src.subjectCode || '',
    subjectDispCode: src.subjectDispCode || src.subjectCode || '',
    subjectName: src.subjectName || '',
    fundUid: src.fundUid || '',
    fundCode: src.fundCode || '',
    fundName: src.fundName || '',
    fundPkgUid: src.fundPkgUid || '',
    fundAmounts: Array.isArray(src.fundAmounts) ? src.fundAmounts : [],
    budgetAmt: amt,
    remark: src.remark
      ? `${src.remark} [직전차수]`
      : 'lastRound 직전차수 불러오기',
    details,
    mod: 'A',
  });
}

/**
 * @returns {{ seeded: boolean, priorKind?: string, rows: object[] }}
 */
export function seedLastRoundDraftIfEmpty({
  tenantCode,
  fiscalYear,
  budgetKindCode,
  inoutDiv,
  existingRows,
}) {
  if (!isLastRoundMode(tenantCode)) {
    return { seeded: false, rows: existingRows || [] };
  }
  if ((existingRows || []).filter((r) => r && r.mod !== 'D').length > 0) {
    return { seeded: false, rows: existingRows || [] };
  }
  const { prior, rows } = loadPriorRoundRowsForLastRound(
    tenantCode,
    fiscalYear,
    budgetKindCode,
    inoutDiv
  );
  if (!prior || !rows.length) {
    return { seeded: false, rows: existingRows || [] };
  }
  const isIncome = String(inoutDiv || '') === '수입';
  const factory = isIncome ? defaultIncomeMaster : defaultExpenseMaster;
  const detailFactory = isIncome ? defaultIncomeDetail : defaultExpenseDetail;
  const drafts = rows.map((r) => cloneMasterFromPrior(r, factory, detailFactory));
  return {
    seeded: true,
    priorKind: String(prior.budgetKindCode),
    priorName: prior.roundName || '',
    rows: drafts,
  };
}
